import { gql, useQuery } from "@apollo/client";
import { GetNotifications } from "./__generated__/GetNotifications";
import { getErrors } from "../../utils";

export const GET_NOTIFICATIONS = gql`
  query GetNotifications {
    notifications {
      id
      dateCreatedUtc
      userId
      orgUserId
      organizationId
      organizationName
      projectId
      projectName
      permitId
      permitNumber
      text
      seen
    }
  }
`;

const ON_NOTIFICATION_CREATED = gql`
  subscription onNotificationCreated($userId: String) {
    notificationCreated(userId: $userId) {
      id
      dateCreatedUtc
      userId
      orgUserId
      organizationId
      organizationName
      projectId
      projectName
      permitId
      permitNumber
      text
      seen
    }
  }
`;

export function useGetNotifications(userId: string) {
  const { loading, error, data, subscribeToMore, refetch } = useQuery<GetNotifications>(GET_NOTIFICATIONS, {
    errorPolicy: "all",
  });

  subscribeToMore({
    document: ON_NOTIFICATION_CREATED,
    variables: { userId: userId },
    updateQuery: (prev, { subscriptionData }) => {
      if (!subscriptionData.data) return prev;
      const newNotification = (subscriptionData.data as any).notificationCreated;

      if (prev.notifications.find((n: any) => n.id === newNotification.id)) return prev;

      return Object.assign({}, prev, {
        notifications: [newNotification, ...prev.notifications],
      });
    },
  });

  return {
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    },
    refetch,
  };
}
